import makeRequest from "../api/apiRequest";
import { constructUrl } from "./apiConfig";
import {
  TriggerValidateIdentityResponseSchema,
  CheckIdVerifyStatusResponseSchema,
} from "../types/identity";
import { validateApiResponse } from "../types/validators";

export const triggerValidateIdentity = async (userId: string): Promise<{
  data?: unknown;
  error?: string;
}> => {
  console.log("identity.ts:triggerValidateIdentity");

  const endpoint = "/trigger_id_validation";
  const url = constructUrl(endpoint);

  const response = await makeRequest(url, "POST", { userid: userId }, {}, {});

  if (response.errorType === 0) {
    try {
      const validated = validateApiResponse(
        TriggerValidateIdentityResponseSchema.shape.data,
        { errorType: 0, data: response.data },
        'triggerValidateIdentity'
      );
      return { data: validated };
    } catch {
      return { error: "Identity validation start response failed validation" };
    }
  } else {
    return { error: response.errorMessage };
  }
};

export const checkIdVerifyStatus = async (
  userId: string,
  sessionId: string
): Promise<{ data?: unknown; error?: string }> => {
  const endpoint = "/get_challenge_value";
  const url = constructUrl(endpoint);

  const response = await makeRequest(
    url,
    "POST",
    { userid: userId, sessionid: sessionId },
    {},
    {}
  );

  if (response.errorType === 0) {
    try {
      const validated = validateApiResponse(
        CheckIdVerifyStatusResponseSchema.shape.data,
        { errorType: 0, data: response.data },
        'checkIdVerifyStatus'
      );
      return { data: validated };
    } catch {
      return { error: "Identity validation status response failed validation" };
    }
  } else {
    return { error: response.errorMessage };
  }
};
